import createUniqueIdentifier from "../Functions/createuniqueIdentifier";

const IsInCart = (cart, paint) => {  
  const uniqueId = createUniqueIdentifier(paint);
  return !!cart.items.find(item => item.uniqueId === uniqueId);
};
const IsInFavorite = (faverite, paint) => {
  return !!faverite.items.find(item => item.id === paint.id);
};

function quantityItem(state, paint) {
  const uniqueId = createUniqueIdentifier(paint);
  const Index = state.items.findIndex(i => i.uniqueId === uniqueId)
  if (Index === -1) return false
  else return state.items[Index].count
}


export { IsInCart, quantityItem, IsInFavorite }

